import React from 'react';

export default function GuestHeader() {
    return (
        <div className="guest-header">
            <div className="logo-block">
                <span className="logo-img"></span>
            </div>
        </div>
    );
}
